import { createSlice } from "@reduxjs/toolkit";
import { createBlog, deleteBlog, fetchBlogs, updateBlog } from "./blogBaseApi";
const blogsSlice = createSlice({
    name: "blogs",
    initialState: {
      blogs: [],
      status: "idle",
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchBlogs.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchBlogs.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.blogs = action.payload;
        })
        .addCase(fetchBlogs.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.error.message;
        })
    },
  });
  
  export default blogsSlice.reducer;